import {loadable} from 'router/routes';
import getInitialState from './redux/get-initial-state';

const SpotDetailsAirport = loadable(() => import('./SpotDetailsAirport'));

SpotDetailsAirport.getInitialState = getInitialState;

export default SpotDetailsAirport;
